<script>
  import { format } from 'svelte-i18n';
  import { Col, Input, Label, Row } from '@sveltestrap/sveltestrap';

  import { Select } from '@client/components/select';

  import { fonts, loading, popular } from '@client/stores/fonts';

  export let fontFamily = '';
  export let fontWeight = '300';

  const ALL_WEIGHTS = ['100', '200', '300', '400', '500', '600', '700', '800', '900'];

  let selectedFont;
  let weights = ALL_WEIGHTS;

  $: options = [
    ...popular.map((fontFamily) => {
      return {
        label: fontFamily,
        value: {
          family: fontFamily,
          variants: ['400', '600']
        },
        group: $format('label.FONT_POPULAR')
      };
    }),
    ...$fonts.map((font) => {
      return {
        label: font.family,
        value: font,
        group: font.category
      };
    })
  ];

  // Populate available weights based on selected font
  $: if (selectedFont && selectedFont.value) {
    const variants = selectedFont.value.variants;
    const availableWeights = new Set();

    variants.forEach((variant) => {
      if (variant === 'regular' || variant === 'italic') {
        availableWeights.add('400');
      } else {
        const weightMatch = variant.match(/^\d+/); // Extracts leading numbers
        if (weightMatch) {
          availableWeights.add(weightMatch[0]);
        }
      }
    });

    weights = Array.from(availableWeights).sort();
  }

  // Set selected font based on fontFamily prop
  $: if (!$loading && options.length && fontFamily) {
    selectedFont = options.find((option) => option.value.family === fontFamily);
  }

  // Set font weight based on available weights, default to 400 or first available weight
  $: if (!$loading && weights) {
    const currentWeightStr = fontWeight ? fontWeight.toString() : undefined;
    const isCurrentWeightAvailable = currentWeightStr && weights.includes(currentWeightStr);

    if (weights.length && !isCurrentWeightAvailable) {
      if (weights.includes('400')) {
        fontWeight = '400';
      } else {
        fontWeight = weights[0];
      }
    } else if (weights.length === 0 && currentWeightStr) {
      fontWeight = undefined;
    }
  }
</script>

<Row class="mb-3">
  <Col class="pb-2">
    <Label>{$format('label.BRAND_FONT_FAMILY')}</Label>
    <Select
      id="font-family"
      groupBy={(item) => item.group}
      items={options}
      clearable={false}
      placeholder={$format('label.FONT_PLACEHOLDER')}
      disabled={$loading}
      loading={$loading}
      showChevron
      bind:value={selectedFont}
      on:change={(e) => {
        fontFamily = e.detail?.value.family;
      }}
    >
      <svelte:fragment slot="item" let:item>
        {#if item.groupHeader}
          {item.value}
        {:else}
          {item.value.family}
        {/if}
      </svelte:fragment>
    </Select>
  </Col>
  <Col xs={3} sm={12} xl={3}>
    <Label>{$format('label.WEIGHT')}</Label>
    <Input type="select" bind:value={fontWeight} disabled={$loading}>
      {#each ALL_WEIGHTS as weight}
        <option value={weight} disabled={!weights.includes(weight)}>
          {weight}
        </option>
      {/each}
    </Input>
  </Col>
</Row>
